module.exports = __webpack_public_path__ + "img/ck.027d5f2a.svg";